<template>
  <div>
    <h1 class="page-header">
      Unit Measure
    </h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button color="info" outline @click="$router.push({ name: 'unit-measure-create' })">
              Add New
            </ts-button>
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input v-model="search" placeholder="Search" style="width: 300px;" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template slot-scope="{ record }">
          <td>{{ record.uom_name_kh }}</td>
          <td>{{ record.uom_name_en }}</td>
          <td>{{ record.uom_qty }}</td>
          <td>
            <div class="checkbox checkbox-css">
              <input type="checkbox" id="cssCheckbox1" :checked="record.is_default" disabled />
              <label for="cssCheckbox1"></label>
            </div>
          </td>
          <td class="text-center">
            <router-link
              :to="{
                name: 'unit-measure-edit',
                params: { id: record.uom_id }
              }"
              title="edit"
              class="mr-2"
            >
              <i class="fas fa-edit"></i>
            </router-link>

            <a href="#" title="delete" class="text-danger" @click="destroy(record.uom_id)">
              <i class="fas fa-trash"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"> </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'position',

  data() {
    return {
      loading: false,
      columns: [
        { name: 'name kh' },
        { name: 'name en' },
        { name: 'quantity' },
        { name: 'default' },
        { name: 'Actions', style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  created() {
    this.$store.commit('inventory/unitMeasure/RESET_STATE')
    this.fetchData()
  },
  computed: {
    ...mapState('inventory/unitMeasure', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.inventory.unitMeasure.search
      },
      set(newValue) {
        this.$store.commit('inventory/unitMeasure/SET_SEARCH', newValue)
        this.$store.commit('inventory/unitMeasure/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('inventory/unitMeasure/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    async destroy(positon_id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('inventory/unitMeasure/destroy', positon_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'unit-measure-create') {
      this.$store.commit('inventory/unitMeasure/RESET_STATE')
    }
    next()
  }
}
</script>
